import React, { useState } from "react";
import { Box, Button, Dialog, DialogContent, Grid, IconButton, TextField, Typography } from "@mui/material";
import { HugeiconsIcon } from "@hugeicons/react";
import { Cancel01Icon, Download01Icon, Edit03Icon, Share01FreeIcons } from "@hugeicons/core-free-icons";
import EditBillDetails from "./EditBillDetail";

const FieldWithLabel = ({ label, value, onChange, multiline = false, type = "text" }) => (
    <Box sx={{ mb: 2 }}>
        <Typography variant="body2" sx={{ fontWeight: "bold", mb: 0.5 }}>
            {label}
        </Typography>
        <TextField
            fullWidth
            size="small"
            type={type}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={`Enter ${label.toLowerCase()}`}
            multiline={multiline}
            rows={multiline ? 2 : 1}
            InputLabelProps={type === "date" ? { shrink: true } : {}}
            InputProps={{ readOnly: true }}
            sx={{
                "& .MuiOutlinedInput-root": {
                    borderRadius: "15px",
                    backgroundColor: "white",
                },
            }}
        />
    </Box>
);

const BillDetails = ({ open, onClose, bill }) => {
    const [openEdit, setOpenEdit] = useState(false);

    if (!bill) return null;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            PaperProps={{ sx: { borderRadius: "20px", boxShadow: "none", } }}
            BackdropProps={{
                sx: {
                    backgroundColor: "rgba(0,0,0,0.1)" // light transparent overlay
                }
            }}
        >
            <DialogContent sx={{ p: 0, backgroundColor: "#ffffff" }}>
                {/* Header */}
                <Box
                    sx={{
                        background: "#EEF4FF",
                        px: 3,
                        py: 1.5,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        borderTopLeftRadius: "12px",
                        borderTopRightRadius: "12px",
                    }}
                >
                    <Typography fontWeight="600" fontSize="16px">
                        {bill.id}
                    </Typography>
                    <Box sx={{ display: "flex", gap: 1 }}>
                        <IconButton size="small" onClick={() => setOpenEdit(true)}>
                            <HugeiconsIcon icon={Edit03Icon} size={20} color="#344054" />
                        </IconButton>
                        {openEdit && (
                            <EditBillDetails
                                open={openEdit}
                                onClose={() => setOpenEdit(false)}
                                onSave={(data) => {
                                    // console.log("Edited Bill:", data);
                                    setOpenEdit(false);
                                }}
                                bill={bill} // prefill data from bill
                            />
                        )}
                        <IconButton size="small">
                            <HugeiconsIcon icon={Share01FreeIcons} size={20} color="#344054" />
                        </IconButton>
                    </Box>
                    <IconButton size="small" onClick={onClose}>
                        <HugeiconsIcon icon={Cancel01Icon} size={20} color="#344054" />
                    </IconButton>
                </Box>

                {/* Content */}
                <Box sx={{ px: 3, py: 3 }}>
                    {/* Top Fields */}
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                            <FieldWithLabel label="Bill No" value={bill.id} />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <FieldWithLabel label="Bill Name" value={bill.bill_name} />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <FieldWithLabel label="Amount" value={bill.amount} />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                            <FieldWithLabel label="Status" value={bill.status} />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <FieldWithLabel label="Bill created date" value={bill.date} />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <FieldWithLabel label="Bill due date" value={bill.due_date} />
                        </Grid>
                    </Grid>

                    {/* Reminder */}
                    {/* <Box sx={{ mt: 4, p: 2, borderRadius: "8px", border: "1px solid #E0E0E0" }}>
            <Typography fontWeight={600} fontSize={14} mb={2}>
              Set reminder
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <FieldWithLabel label="Date selected" value={bill.reminder_date} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FieldWithLabel label="Notify" value={bill.notify} />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body2" sx={{ fontWeight: "bold", mb: 0.5 }}>
                  Comments
                </Typography>
                <textarea
                  disabled
                  value={bill.comments}
                  style={{
                    width: "100%",
                    borderRadius: "15px",
                    border: "1px solid #ccc",
                    padding: "6px 10px",
                    backgroundColor: "white",
                    minHeight: "50px",
                  }}
                />
              </Grid>
            </Grid>
          </Box> */}

                    {/* About this Bill */}
                    <Box sx={{ mt: 3 }}>
                        {/* <Typography variant="body2" sx={{ fontWeight: "bold", mb: 0.5 }}>
                            About this Bill
                        </Typography>
                        <textarea
                            disabled
                            value={bill.description}
                            style={{
                                width: "100%",
                                borderRadius: "15px",
                                border: "1px solid #ccc",
                                padding: "6px 10px",
                                backgroundColor: "white",
                                minHeight: "50px",
                            }}
                        /> */}
                        <FieldWithLabel
                            label="About this Bill"
                            value={bill.description}
                        />
                    </Box>

                    {/* Service Center Details */}
                    {/* <Box sx={{ mt: 3 }}>
            <Typography fontWeight={600} fontSize={14} mb={2}>
              Service Center Details
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <FieldWithLabel label="Service Manager Name" value={bill.service_manager_name} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FieldWithLabel label="Mobile number" value={bill.mobile_no} />
              </Grid>
            </Grid>
          </Box> */}

                    {/* Bill Image */}
                    <Box sx={{ mt: 3, textAlign: "center" }}>
                        {bill.img ? (
                            <img
                                src={bill.img}
                                alt="Bill Preview"
                                style={{ width: "40%", borderRadius: "10px", border: "1px solid #E0E0E0" }}
                            />
                        ) : (
                            <Typography sx={{ color: "#999", fontSize: "14px" }}>
                                No Preview Image
                            </Typography>
                        )}
                    </Box>

                    {/* Download */}
                    <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
                        <Button
                            variant="contained"
                            startIcon={<HugeiconsIcon icon={Download01Icon} />}
                            sx={{
                                background: "#3EC27F",
                                color: "#fff",
                                borderRadius: "100px",
                                px: 5,
                                py: 1.5,
                                textTransform: "none",
                                fontWeight: 600,
                                fontSize: "15px",
                                "&:hover": { background: "#38B36F" },
                            }}
                        >
                            Download
                        </Button>
                    </Box>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default BillDetails;
